export default "__VITE_ASSET__DGAh$rZq__"